import { ThirdwebNftMedia } from '@thirdweb-dev/react'
import { Item } from '~/domain/Item'
import { NftCardBadge } from '~/components/NftCardBadge'
import styles from './index.module.scss'

interface NftMediaProps  {
  nft: Item
}

export const NftMedia: React.FC<NftMediaProps> = ({ nft: item }) => {
  return (
    <div
      data-testid="nft-media"
      className={ styles['nft-media'] }
    >
      <NftCardBadge
        nft={ item }
        className={ 'media' }
      />

      <ThirdwebNftMedia
        metadata={ item.nft.metadata }
        className={ styles.image }
      />
    </div>
  )
}
